import { AppStore, IAppStore } from './appStore';
import { ComposeVervAPIServices } from 'utils/services/VervAPI/VervAPIServices';
import { InMemoryCached } from 'utils/services/VervAPI/VervAPIServices+InMemoryCached';
import { composeVervSentryErrorLogger } from 'utils/errorLogger/appErrorLogger';
import { composeAnalyticsEventsTracker } from 'utils/analytics';
import {
	UPGRADE_LIFETIME_VERSION,
	UPSALE_PDF,
} from 'modules/activationInstructions/components/paymentSuccessfulV1/params';
import { ActivationInstructionsStore } from 'modules/activationInstructions/store';
import { PaymentStore } from 'modules/payment/store';
import { PaywallStore } from 'modules/paywall/store';
import { SurveyStore } from 'modules/survey/store';
import { ABTestsStore } from './abTestsStore';
import { UnitsStore } from './unitsStore';
import { NavigationStore as PaymentNavigationStore } from 'modules/payment/store/navigationStore';
import { URLSearchParams } from 'url';

const composeAppStore = () => {
	const errorLogger = composeVervSentryErrorLogger();

	if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
		errorLogger.initialize();
	} else {
		console.log('sentry disabled');
	}

	const VervAPI = InMemoryCached(
		ComposeVervAPIServices(process.env.REACT_APP_API_URL, errorLogger),
	);

	const storage: Storage = window.localStorage;
	const activationInstructionsStoreCreator = (searchParams: URLSearchParams) =>
		new ActivationInstructionsStore(
			storage,
			searchParams.get('upgradeLifetime') as UPGRADE_LIFETIME_VERSION,
			searchParams.get('upsalePdf') as UPSALE_PDF,
		);
	const paymentStoreCreator = (searchParams: URLSearchParams) =>
		new PaymentStore(searchParams, storage, VervAPI);

	return new AppStore({
		location: window.location,
		storage,
		VervAPI,
		eventsTracker: composeAnalyticsEventsTracker(VervAPI),
		errorLogger,
		unitsStoreCreator: () => new UnitsStore(navigator.language),
		surveyStoreCreator: () => new SurveyStore(),
		abTestsStoreCreator: (searchParams: URLSearchParams) => new ABTestsStore(searchParams),
		paymentNavigationStoreCreator: () => new PaymentNavigationStore(),
		activationInstructionsStoreCreator,
		paymentStoreCreator,
		paywallStoreCreator: (searchParams: URLSearchParams) => new PaywallStore(searchParams, storage),
	});
};

export const appStore: IAppStore = composeAppStore();

export * from './appStore';
export * from './uiStore';
